import React, { useState } from "react";
import logo from "../../assets/logo.png";
import { loginCapital } from "../../services/authService";
// import { loginCapital } from "../services/authService"; // your separate endpoint

const CapitalLoginModal = ({ show, onSuccess, checking }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [authError, setAuthError] = useState("");

  if (!show) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setAuthError("");

    // Validation
    const newErrors = {};
    if (!username.trim()) newErrors.username = "Username is required";
    if (!password.trim()) newErrors.password = "Password is required";
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      setLoading(true);
      const response = await loginCapital({ username, password });

      console.log("CApital Response", response);
      if (response.success) {
        sessionStorage.setItem("capital_logged_in", "true");
        onSuccess(); // close modal, show capital page
      } else {
        setAuthError(response.message || "Invalid credentials");
      }
    } catch (err) {
      console.error(err);
      setAuthError("Invalid username or password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Backdrop */}
      <div
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(0,0,0,0.5)", // Semi-transparent background
          backdropFilter: "blur(10px)", // Apply blur effect
          zIndex: 1040,
        }}
      />

      {/* Modal */}
      <div
        role="dialog"
        aria-labelledby="capitalLoginTitle"
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 9999,
          background: "#fff",
          borderRadius: "16px",
          padding: "2rem 2.5rem",
          width: "min(440px, 95vw)",
          boxShadow: "0 8px 40px rgba(0,0,0,0.25)",
        }}
      >
        <div
          onClick={() => {
            window.history.back();
          }}
          className="position-absolute"
          style={{
            cursor: "pointer",
          }}
        >
          <i className="fas fa-arrow-left"></i>
        </div>
        {/* Header */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "0.5rem",
            gap: "0.5rem",
          }}
        >
          <img
            src={logo}
            alt="KW Logo"
            style={{ height: "3rem", width: "3rem" }}
          />
          <span
            style={{
              fontFamily: "'Inria Serif', serif",
              fontSize: "1.5rem",
              fontWeight: 700,
              color: "#202020",
            }}
          >
            KW{" "}
            <span style={{ fontSize: "1rem", fontWeight: 400 }}>
              GOLD &amp; SILVER
            </span>
          </span>
        </div>

        <h2
          id="capitalLoginTitle"
          style={{
            textAlign: "center",
            fontSize: "1.3rem",
            fontWeight: 700,
            color: "#3d3d3d",
            marginBottom: "0.25rem",
          }}
        >
          Capital Access
        </h2>
        <p
          style={{
            textAlign: "center",
            fontSize: "0.85rem",
            color: "#888",
            marginBottom: "1.5rem",
          }}
        >
          This section is protected. Please verify your identity.
        </p>

        {/* Auth error */}
        {authError && (
          <div
            style={{
              background: "#fff3f3",
              border: "1px solid #f5c2c7",
              borderRadius: "8px",
              padding: "0.5rem 0.75rem",
              color: "#842029",
              fontSize: "0.875rem",
              marginBottom: "1rem",
            }}
          >
            {authError}
          </div>
        )}

        {checking ? (
          <div style={styles.container} className="p-3 text-center">
            Checking...
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            {/* Username */}
            <div style={{ marginBottom: "1rem" }}>
              <label
                htmlFor="cap-username"
                style={{
                  fontSize: "0.9rem",
                  fontWeight: 600,
                  color: "#333",
                  display: "block",
                  marginBottom: "0.4rem",
                }}
              >
                <i className="bi bi-person me-2"></i>Username
              </label>
              <input
                id="cap-username"
                type="text"
                placeholder="Enter username"
                value={username}
                onChange={(e) => {
                  setUsername(e.target.value);
                  setErrors((p) => ({ ...p, username: "" }));
                }}
                style={{
                  width: "100%",
                  padding: "0.55rem 0.85rem",
                  border: `1px solid ${errors.username ? "#dc3545" : "#ced4da"}`,
                  borderRadius: "8px",
                  fontSize: "0.95rem",
                  outline: "none",
                  boxSizing: "border-box",
                }}
              />
              {errors.username && (
                <span style={{ color: "#dc3545", fontSize: "0.8rem" }}>
                  {errors.username}
                </span>
              )}
            </div>

            {/* Password */}
            <div style={{ marginBottom: "1.25rem", position: "relative" }}>
              <label
                htmlFor="cap-password"
                style={{
                  fontSize: "0.9rem",
                  fontWeight: 600,
                  color: "#333",
                  display: "block",
                  marginBottom: "0.4rem",
                }}
              >
                <i className="bi bi-lock me-2"></i>Password
              </label>
              <input
                id="cap-password"
                type={showPassword ? "text" : "password"}
                placeholder="Enter password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setErrors((p) => ({ ...p, password: "" }));
                }}
                style={{
                  width: "100%",
                  padding: "0.55rem 2.5rem 0.55rem 0.85rem",
                  border: `1px solid ${errors.password ? "#dc3545" : "#ced4da"}`,
                  borderRadius: "8px",
                  fontSize: "0.95rem",
                  outline: "none",
                  boxSizing: "border-box",
                }}
              />
              {/* Eye toggle */}
              <span
                onClick={() => setShowPassword((p) => !p)}
                style={{
                  position: "absolute",
                  right: "0.75rem",
                  top: "2.15rem",
                  cursor: "pointer",
                  color: "#888",
                }}
              >
                <i
                  className={`bi ${showPassword ? "bi-eye-fill" : "bi-eye-slash-fill"}`}
                />
              </span>
              {errors.password && (
                <span style={{ color: "#dc3545", fontSize: "0.8rem" }}>
                  {errors.password}
                </span>
              )}
            </div>

            {/* Submit */}
            <button
              type="submit"
              disabled={loading}
              style={{
                width: "100%",
                background: loading ? "#a89ad6" : "#7c6fcd",
                color: "#fff",
                border: "none",
                borderRadius: "10px",
                padding: "0.65rem",
                fontSize: "1rem",
                fontWeight: 600,
                cursor: loading ? "not-allowed" : "pointer",
                transition: "background 0.2s",
              }}
              onMouseEnter={(e) => {
                if (!loading) e.currentTarget.style.background = "#6a5fc1";
              }}
              onMouseLeave={(e) => {
                if (!loading) e.currentTarget.style.background = "#7c6fcd";
              }}
            >
              {loading ? "Verifying..." : "Unlock Capital"}
            </button>
          </form>
        )}
      </div>
    </>
  );
};

export default CapitalLoginModal;

const styles = {
  container: {
    backgroundColor: "#f0f0f0",
    fontFamily: "Arial, sans-serif",
  },
};
